import React from "react";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/styles";
import { styles } from "../../assets/styles";

function ButtonWithStyle({ children, classes, variant, type, onClick, ...props }) {
	return (
		<Button className={classes.root} variant={variant} type={type} onClick={onClick} {...props}>
			{children}
		</Button>
	);
}

export default withStyles(styles)(ButtonWithStyle);
